import React from "react";
import ShipmentDetailsModel, { steppedProgressDataType } from "../../app/data/tracking/ShipmentDetailsModel";
import { ShipmentStatuses } from "../../app/data/common/shipmentStatuses";
import TrailerLocation from "../../features/trailer-location/trailerLocation";
import "./steppedProgress.scss";

interface SteppedProgressProps {
  className?: string;
  shipmentDetails: ShipmentDetailsModel;
}

const SteppedProgress: React.FC<SteppedProgressProps> = (props) => {
  const isOutForDelivery = () => props.shipmentDetails.status?.description === ShipmentStatuses.outForDelivery;

  const isLastActiveStep = (i: number) => {
    if (!props.shipmentDetails.progress[i].reached) return false;
    if (props.shipmentDetails.progress[i + 1] && !props.shipmentDetails.progress[i + 1].reached) return true;
    return false;
  };

  return (
    <ul className={`xgs-stepped-progress ${props.className ? props.className : ""}`}>
      {props.shipmentDetails.progress.map((step: steppedProgressDataType, index: number) => (
        <li
          className={`${step.reached ? "reached" : ""} ${!step.completed && step.reached ? "current" : ""}`}
          key={index}
        >
          <div className="xgs-stepped-progress__step__header">{step.statusTitle}</div>
          {/*{step.date && <div className="xgs-stepped-progress__step__subheader">{step.date.toUiDateFormat()}</div>}*/}
          {isOutForDelivery() &&
            props.shipmentDetails.trailer &&
            (step.statusTitle === "Out for Delivery" || isLastActiveStep(index)) && (
              <TrailerLocation invoiceNumber={props.shipmentDetails.invoice.invoiceNumber} textMode={true} />
            )}
        </li>
      ))}
    </ul>
  );
};

export default SteppedProgress;
